import { BasePagedSearchCriteria } from './BaseSearchCriteria';

export interface GuardianSearchCriteria extends BasePagedSearchCriteria {
  companyName?: string;
  organizationId?: number;
}

export const GUARDIAN_SEARCH_CRITERIA_KEY = 'GuardianSearchCriteria';
